const curriculum = {
  name: "Учебная программа",
  keyName: "curriculum",
  definedEntries: [
    {
      slug: "Slug"
    },
    {
      "title": "Title",
      "subtitle": "Description",
      _size: 500
    },
    {
      "download.button": "Текст кнопки",
      "download.link": "Ссылка на кнопке"
    }
  ],
  definedValues: {
    "module.duration.w": "{weeks, plural, =0 { } one {{weeks} неделя } two {{weeks} недели } few {{weeks} недели } other {{weeks} недель}}",
    "module.duration.h": "{hours, plural, =0 { } one {{hours} час } two {{hours} часа} few {{hours} часа } other {{hours} часов}}",
    "module.duration.s": " "
  },

  blockKeyName: "module",
  blockKeyTitle: "Модуль",
  tableColumns: {
    projects: { title: "Кол-во проектов", size: 2 },
    tags: { title: "Кол-во тегов", size: 2 },
    time: { title: "Длительность", size: 1 },
    timeType: { title: "Тип времени", size: 1, default: "s" }
  },
  row(x: number, el: { projects: string, tags: string, time: string, timeType: string }, push: (key: string, value: string) => void) {
    push(`title`, `Модуль_${x}`)
    if (el.time) {
      push(`duration.value`, el.time.toString())
    }

    push(`duration.units`, el.timeType || 's')
    
    push(`name`, `Название_модуля_${x}`)
    push(`description`, `Описание_модуля_${x}`)
    
    const projectsCount = parseInt(el.projects as any)
    if (projectsCount) {
      push(`projects.count`, (projectsCount || 0).toString())
      if (projectsCount) {
        for (let y = 1; y <= Math.min(projectsCount, 30); y++) {
          push(`project.${y}.name`, `Модуль_${x}_Проект_${y}`)
          push(`project.${y}.description`, `Модуль_${x}_Описание_проекта_${y}`)
        }
      }
    }

    const tagsCount = parseInt(el.tags as any)
    if (tagsCount) {
      push(`tags.count`, (tagsCount || 0).toString())
      if (tagsCount) {
        for (let n = 1; n <= Math.min(tagsCount, 30); n++) {
          push(`${x}.tag.${n}.text`, `Модуль_${x}_Тэг_${n}`)
        }
      }
    }
  }

}

export default curriculum